import {
  Component,
  ChangeDetectionStrategy,
  output,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlashMapToolbarTranslations, FLASH_MAP_TRANSLATIONS } from '../../i18n/flash-map-i18n';

@Component({
  selector: 'lib-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class TopToolbarComponent {
  readonly translations = input<FlashMapToolbarTranslations>(FLASH_MAP_TRANSLATIONS.en.toolbar);

  readonly helpClick = output<void>();
  readonly downloadClick = output<void>();
  readonly shareClick = output<void>();

  onHelpClick(): void {
    this.helpClick.emit();
  }

  onDownloadClick(): void {
    this.downloadClick.emit();
  }

  onShareClick(): void {
    this.shareClick.emit();
  }
}

